module.exports = __webpack_public_path__ + "img/yishi9.e592628b.jpg";